//@ts-nocheck

import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch } from '../hooks/useAppDispatch';
import { useAppSelector } from '../hooks/useAppSelector';
import { fetchAllJobsData, fetchJobs } from '../store/slices/jobs/jobSlice';
import JobFilters from '../components/Jobs/JobFilters';
import JobListingByDepartment from '../components/Jobs/JobListingByDepartment';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AuthValidation from './AuthValidation';
import { DialogBackdrop, DialogPanel, DialogTitle, Dialog } from '@headlessui/react'
import { CrossIcon } from '../components/icons/Icons';
import { ListboxButton, ListboxOption, ListboxOptions, Listbox } from '@headlessui/react'
import { createCandidateLogin, verifyCandidateOtp } from '../store/slices/jobAuth/JobAuthSlice';
import { useJobData } from '../components/JobDataProvider';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';


interface EmailLoginFormProps {
  onSubmit: (email: string) => void;
  onBack: () => void;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}


const EmailLoginForm: React.FC<EmailLoginFormProps> = ({ onSubmit, onBack }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const dispatch = useAppDispatch();

  const { createCandidateStatus, createCandidateError } = useAppSelector((state: RootState) => state.jobauth);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (!emailRegex.test(value)) {
      setError('Please enter a valid email address');
    } else {
      setError('');
    }
  };


  const handleSubmit = async (e: React.FormEvent) => {

    e.preventDefault();

    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return; // Prevent submission
    }
    const result = await dispatch(createCandidateLogin({ payload: { email } })).unwrap();

    onSubmit(email);
  };





  return (
    <form
      onSubmit={handleSubmit}
      className="mt-[-0.6rem]">
      <label htmlFor="email" className="wg-label mb-2 capitalize inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5 font-medium">
        Email
      </label>
      <input
        type="text"
        value={email}
        onChange={handleChange}
        placeholder="Enter your email"
        className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline outline-0  border-[#d1d5db] -outline-offset-1 outline-gray-300 placeholder:text-gray-400 input_hover sm:text-sm/6"
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

      <div className='flex items-center justify-end mt-7'>
        {/* <button className=' text-[13px] text-[#266df0]'>
          Resend Otp
        </button> */}
        <button
          type="submit"
          className="flex justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm 2  button-hover"

        >
          {createCandidateStatus === 'loading' ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Send OTP
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : (
            'Send OTP'
          )}

        </button>
        {/* <button
                type="button"
                onClick={onBack}
                className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
            >
                Back
            </button> */}
      </div>
    </form>
  );
};

// components/Auth/OtpVerification.tsx
interface OtpVerificationProps {
  email: string;
  onSuccess: () => void;
  onBack: () => void;
  setModalOpen: (open: boolean) => void
}

const OtpVerification: React.FC<OtpVerificationProps> = ({
  email,
  onSuccess,
  onBack,
  setModalOpen
}) => {
  const [otp, setOtp] = useState<string[]>(Array(6).fill(''));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const { verifyCandidateStatus, verifyCandidateError } = useAppSelector((state) => state.jobauth);
  const dispatch = useAppDispatch();


  useEffect(() => {
    // Focus the first input on component mount
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index: number, value: string) => {
    // Only allow numbers
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next input
    if (value !== '' && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    // Handle backspace
    if (e.key === 'Backspace') {
      if (otp[index] === '' && index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
        inputRefs.current[index - 1]?.focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);
      }
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const pastedNumbers = pastedData.replace(/[^\d]/g, '').split('').slice(0, 6);

    const newOtp = [...otp];
    pastedNumbers.forEach((num, index) => {
      if (index < 6) {
        newOtp[index] = num;
      }
    });
    setOtp(newOtp);

    // Focus last filled input or next empty input
    const focusIndex = Math.min(pastedNumbers.length, 5);
    inputRefs.current[focusIndex]?.focus();
  };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const otpString = otp.join('');
  //   if (otpString.length === 6) {
  //     // Add your OTP verification logic here
  //     localStorage.setItem('token', 'your-auth-token');
  //     onSuccess();
  //   }
  // };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const otpString = otp.join('');

    if (otpString.length === 6) {
      try {
        const res = await dispatch(verifyCandidateOtp({
          payload: {
            email: email,
            otp: otpString
          }
        })).unwrap();
        if (res.status === 200) {
          localStorage.setItem('accessToken', res?.accessToken);
          localStorage.setItem('email', res?.candidate?.email);
          localStorage.setItem('name', res?.candidate?.name)
          if (typeof onSuccess === 'function') {
            onSuccess();
          }
          setModalOpen(false)

        }



      } catch (error) {
        console.error('OTP verification failed:', error);
      }
    }
  };



  return (
    <form id="otp-form" onSubmit={handleSubmit}>
      <div className="flex items-center justify-center gap-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <input
            key={index}
            ref={el => inputRefs.current[index] = el}
            type="text"
            value={otp[index]}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            className="w-10 h-10 lg:w-14 lg:h-14 text-center border-[#a9a9bc52] focus:border-[2px] input_hover focus:border-solid border-[0.5px] text-[14px] lg:text-[20px] font-[600] text-slate-900 bg-slate-100 hover:border-slate-200 appearance-none rounded-lg p-2 lg:p-4 outline-none focus:bg-white focus:ring-0"
            maxLength={1}
          />
        ))}
      </div>
      <div className="max-w-[260px] mx-auto mt-6">
        <button
          type="submit"
          className="mt-4 w-full rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline button-hover"
          disabled={otp.join('').length !== 6}
        >
          {verifyCandidateStatus === 'loading' ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Send OTP
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : (
            'Send OTP'
          )}
        </button>
      </div>
    </form>
    // <form onSubmit={handleSubmit} className="space-y-4">
    //     <input
    //         type="text"
    //         value={otp}
    //         onChange={(e) => setOtp(e.target.value)}
    //         placeholder="Enter OTP"
    //         className="w-full p-2 border rounded"
    //         maxLength={6}
    //         required
    //     />
    //     <button type="submit" className="w-full bg-primary text-white p-2 rounded">
    //         Verify
    //     </button>
    //     <button
    //         type="button"
    //         onClick={onBack}
    //         className="w-full bg-transparent text-gray-500 p-2"
    //     >
    //         Back
    //     </button>
    // </form>
  );
};

// components/Auth/GoogleLoginButton.tsx
interface GoogleLoginButtonProps {
  onSuccess: () => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess }) => {
  const navigate = useNavigate()
  const [loadingGoogle, setLoadingGoogle] = useState(false); // ✅ loading state


  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      setLoadingGoogle(true); // start loading
      try {
        const res = await axios.post(
          'https://atsapi.teamer.app/v1/auth/google',
          { code: codeResponse.code },
          { withCredentials: true }
        );

        if (res.data?.status === 200) {
          localStorage.setItem('accessToken', res.data.data?.accessToken);
          localStorage.setItem('email', res.data.data?.candidate?.email);
          localStorage.setItem('name', res.data.data?.candidate?.name)
          navigate('/applications')
          if (typeof onSuccess === 'function') {
            onSuccess();
          }


        }
      } catch (err) {
        console.error('Login failed:', err);
      } finally {
        setLoadingGoogle(false); // stop loading
      }
    },
    onError: (errorResponse) => {
      console.error('Google login error:', errorResponse);
      setLoadingGoogle(false)
    },
  });

  return (
    <button
      onClick={() => login()}
      className="flex w-full items-center h-[40px] justify-center gap-3 rounded-md px-3 py-2 text-sm font-semibold text-gray-900 border border-solid border-[#e7e7e8]"
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 488 512"
        focusable="false"
        className=""
        aria-hidden="true"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
      </svg>
      {loadingGoogle ? (
        <div className='flex items-center justify-center gap-[12px]'>
          Continue with Google
          <div className="simple-spinner">
            <span style={{borderRightColor: '#20808d'}}></span>
          </div>
        </div>
      ) : (
        'Continue with Google'
      )}

    </button>
  );
};

function JobListing({ onLoginSuccess }: any) {
  const dispatch = useAppDispatch();
  const { jobs, fetchAllJobs, fetchAllJobsLoading, fetchAllJobsError } =
    useAppSelector((state) => state.jobs);
  const { base_slug } = useParams();
  const navigate = useNavigate();
  const [is404, setIs404] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams(); // Add this line
  const [skipEffect, setSkipEffect] = useState(false);
  const [ModelOpen, setModalOpen] = useState(false)
  const [LoginLoading, SetLoginLoading] = useState(false)
  const [step, setStep] = useState<'initial' | 'email' | 'otp'>('initial');
  const [email, setEmail] = useState('');
  const [otpSaveDetails, setOtpSaveDetails] = useState('')
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { jobDetailsData, loading, error } = useJobData();



  // Function to get current filters from URL
  const getFiltersFromUrl = () => {
    const filters: Record<string, string> = {};


    // Get all filter values from URL
    ['work', 'location', 'team', 'workType'].forEach(param => {
      const value = searchParams.get(param);
      if (value) {
        // Single key assignment using switch or if-else logic
        let key;
        switch (param) {
          case 'team':
            key = 'job_department_id';
            break;
          case 'workType':
            key = 'job_type';
            break;
          case 'location':
            key = 'job_location';
            break;
          case 'work':
            key = 'job_workplace_type';
            break;
          default:
            key = param;
        }
        filters[key] = value;
      }
    });

    return filters;
  };

  // clear filter
  const handleClearFilters = () => {
    setSkipEffect(true);

    setSearchParams(new URLSearchParams());
    navigate(`/${base_slug}`, { replace: true });

    if (jobDetailsData?.department && jobDetailsData?.location) {
      const emptyFilters = {
        work: '',
        location: '',
        team: '',
        workType: ''
      };

      dispatch(fetchAllJobsData({
        baseSlug: base_slug,
        filters: {}
      }));
    }
  };

  // useEffect(() => {
  //   setIs404(false);
  //   if (!jobDetailsData?.base) {
  //     dispatch(fetchJobs(base_slug))
  //       .unwrap()
  //       .catch((error) => {
  //         if (error?.status === 404 || error?.response?.status === 404) {
  //           setIs404(true);
  //         }
  //       });
  //   }
  // }, [dispatch, base_slug, jobDetailsData?.base]);



  // job listing by department
  useEffect(() => {
    if (!is404 && !skipEffect) {
      const currentFilters = getFiltersFromUrl();

      dispatch(fetchAllJobsData({
        baseSlug: base_slug,
        filters: currentFilters
      }))
        .unwrap()
        .catch((error) => {
          if (error?.status === 404 || error?.response?.status === 404) {
            setIs404(true);
          }
        });
    }
    setSkipEffect(false);
  }, [dispatch, base_slug, searchParams, is404]);


  // Set primary color from API response
  useEffect(() => {
    if (jobDetailsData?.base?.primary_color) {
      // Increase the percentage to make the difference more noticeable
      // Using 0.33 instead of 0.0033 (33% instead of 0.33%)
      const lighterShade = calculateLighterShade(jobDetailsData.base.primary_color, 0.33);
      const mainBgShare = calculateLighterShade(jobDetailsData.base.primary_color, 0.93);
      // console.log('Primary Color:', jobs.base.primary_color);
      // console.log('Hover Color:', lighterShade);

      document.documentElement.style.setProperty('--primary-color', jobDetailsData.base.primary_color);
      document.documentElement.style.setProperty('--hover-primary-color', lighterShade);
      document.documentElement.style.setProperty('--main-bg-color', mainBgShare);
    }
  }, [jobDetailsData?.base?.primary_color]);

  // Helper function to calculate lighter shade for hover state
  const calculateLighterShade = (hex, percent) => {
    // Remove the hash if it exists
    hex = hex.replace('#', '');

    // Convert hex to RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Calculate lighter values (adding the percentage)
    r = Math.min(255, Math.round(r + (255 - r) * percent));
    g = Math.min(255, Math.round(g + (255 - g) * percent));
    b = Math.min(255, Math.round(b + (255 - b) * percent));

    // Convert back to hex
    const toHex = (n) => {
      const hex = n.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };


  const handleLoginOpenModal = () => {
    // setModalOpen(true)
    // setStep('initial');
    navigate('/')
  }

  // Implementation with outside click detection using useRef and useEffect



  useEffect(() => {
    // Get the email from localStorage
    const emailFromStorage = localStorage.getItem('email');
    if (emailFromStorage) {
      setOtpSaveDetails(emailFromStorage);
    }

    // Function to close dropdown when clicking outside
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    // Add event listener when dropdown is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);




  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('email');
    localStorage.removeItem('name');
    navigate('/', { replace: true })

  }


  if (is404) {
    return <AuthValidation />;
  }



  return (
    <>
      <div className="flex-1 p-0 h-full main-bg-background">
        <div className="min-h-full max-w-full" style={{ margin: "0px auto" }}>

          <div className="flex items-stretch flex-row gap-0 w-full h-full relative overflow-x-hidden overflow-y-hidden">

            <main className="relative flex-1 flex">

              <div className="overflowing-element hovered mq1023:max-w-full mq1800:max-w-[100%] mq3000:max-w-[100%] flex-1 w-full overflow-y-auto h-screen">
                <div className='pt-1 lg:pt-3 pb-1 cursor-pointer flex justify-end px-3'>

                  {/* {loading || !jobDetailsData?.base?.logo ? (
                    <div className="h-6 w-6 rounded-[5px] bg-gray-300 animate-pulse"></div>
                  ) : (
                    <img
                      src={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${jobDetailsData?.base?.logo}`}
                      alt="Company Logo"
                      className="h-6 w-6 rounded-[5px]"
                    />
                  )} */}

                  {otpSaveDetails ? (
                    <Listbox value={dropdownOpen} onChange={setDropdownOpen}>
                      {({ open }) => (
                        <div className="relative z-10 flex">
                          <ListboxButton className="relative w-auto min-w-[110px] flex items-center gap-[6px]  pl-3 py-[0px]   cursor-pointer">
                            <div className='flex items-center gap-1.5 justify-between hover:ring-1 ring-gray-200 p-1 rounded-md'>
                              <span className="block truncate text-[13px] font-medium text-gray-600">{otpSaveDetails}</span>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-3">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                              </svg>
                            </div>
                          </ListboxButton>

                          <ListboxOptions className="absolute z-10 mt-1 top-[32px] right-0 bg-white w-full overflow-hidden rounded-lg border border-gray-200 p-1 shadow-lg">
                            <ListboxOption
                              key="applicationlist"
                              value={true}
                              onClick={() => navigate('/applications')}

                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                  'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-[6px]  text-[13px]   outline-none transition-colors'
                                )
                              }
                            >
                              <span className="block truncate font-normal leading-4">Application List</span>
                            </ListboxOption>

                            <ListboxOption
                              key="logout"
                              value={true}
                              onClick={handleLogout}
                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                  'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-[6px]  text-[13px]   outline-none transition-colors'
                                )
                              }
                            >
                              <span className="block truncate font-normal leading-4">Logout</span>
                            </ListboxOption>
                          </ListboxOptions>
                        </div>
                      )}
                    </Listbox>
                  ) : (
                    <span
                      onClick={handleLoginOpenModal}
                      className='flex w-fit items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 text-xs font-medium text-gray-600 hover:ring-1 ring-gray-200'
                    >
                      Login
                    </span>
                  )}
                </div>
                <div className="max-w-full md:max-w-[710px] lg:max-w-[710px] pb-4 rounded-none md:rounded-2xl lg:rounded-2xl m-auto my-0 md:my-4 lg:my-1 bg-white">
                  {loading ? (
                    <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  ) : error ? (
                    <div className="text-red-500 text-center">Failed to load jobs</div>
                  ) : (
                    <>
                      <div className="relative">
                        {loading || !jobDetailsData?.base?.cover_image ? (
                          <div className="w-full object-cover rounded-t-none md:rounded-t-2xl lg:rounded-t-2xl h-full max-h-[200px] min-h-[200px] bg-gray-300 animate-pulse"></div>
                        ) : (
                          <img
                            src={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${jobDetailsData?.base?.cover_image}`}
                            alt="Cover Image"
                            className="w-full object-cover rounded-t-none md:rounded-t-2xl lg:rounded-t-2xl h-full max-h-[200px] min-h-[200px]"
                          />
                        )}

                        {loading || !jobDetailsData?.base?.logo ? (
                          <div className="h-[70px] md:h-[88px] lg:h-[88px] w-[70px] md:w-[88px] lg:w-[88px] border-[5px] border-solid border-[#f5f5f5] rounded-2xl 
                                                            md:rounded-[2rem] lg:rounded-[2rem absolute top-[164px] lg:top-[160px]  left-[18px] md:left-[50px] lg:left-[50px] bg-gray-300 animate-pulse"></div>
                        ) : (
                          <img
                            src={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${jobDetailsData?.base?.logo}`}
                            alt="Company Logo"
                            className="h-[70px] md:h-[88px] lg:h-[88px] w-[70px] md:w-[88px] lg:w-[88px] border-[5px] border-solid border-[#f5f5f5] bg-[#f5f5f5] rounded-2xl 
                                                            md:rounded-[2rem] lg:rounded-[2rem] absolute top-[164px] lg:top-[160px]  left-[18px] md:left-[50px] lg:left-[50px]"
                          />
                        )}
                      </div>

                      <div className="px-4 md:px-2 lg:px-[50px] w-full max-w-full ml-0">
                        {/* <div className="mb-[15px] mt-[67px] bg-primary hover:bg-hoverPrimary w-full p-0 text-[20px] md:text-[24px] lg:text-[24px] leading-5 font-medium text-dark-black-100">
                          {jobs?.base?.name}hjhjkh
                        </div> */}
                        <div className="mb-[10px] lg:mb-[15px] base_name mt-[40px] capitalize md:mt-[50px] lg:mt-[67px] w-full p-0 text-[20px] md:text-[24px] lg:text-[24px] leading-7 font-medium text-dark-black-100">
                          {jobDetailsData?.base?.name}
                        </div>
                        <div className="items-center text-left lg:text-start capitalize gap-x-2 rounded-lg bg-transparent text-dark-black-200 font-[500] text-[0.8125rem] focus:outline-none justify-start inline-flex">
                          {jobDetailsData?.base?.description}
                        </div>
                      </div>


                      <hr className="my-6 mx-0 md:mx-[52px] lg:mx-[52px]"></hr>
                      <div className='px-4 md:px-2 lg:px-[52px] w-full max-w-full mt-8 ml-0'>
                        <div className='flex items-center justify-between mb-6'>
                          <h1 className='text-[14px] capitalize lg:text-[1.125rem]
                      font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem]'>Open Positions - {fetchAllJobs.totalCount}</h1>
                          {
                            searchParams.size > 0 &&

                            <button
                              onClick={handleClearFilters}
                              className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10 capitalize"
                            >
                              Clear filter
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="icon icon-tabler icons-tabler-filled icon-tabler-square-rounded-x w-[1rem] h-[1rem] ml-1 text-[#808080]"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path
                                  d="M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm-1.489 7.14a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z"
                                  fill="currentColor"
                                  strokeWidth={0}
                                />
                              </svg>
                            </button>
                          }

                        </div>
                        <JobFilters
                          locations={jobDetailsData?.location || []}
                          departments={jobDetailsData?.department || []}
                          primaryColor={jobDetailsData?.base?.primary_color}
                        />
                      </div>


                    </>
                  )}
                  <div className=' w-full max-w-full mt-8'>
                    {fetchAllJobsLoading ? (
                      <div className="flex items-center justify-center py-8 h-[200px]">
                        <div className="simple-spinner-loader">
                          <span></span>
                        </div>
                      </div>
                    ) : (
                      fetchAllJobs && (
                        <JobListingByDepartment
                          jobsByDepartment={fetchAllJobs.jobsByDepartment}
                          departments={jobDetailsData?.department || []}
                          locations={jobDetailsData?.location || []}
                          primaryColor={jobDetailsData?.base?.primary_color}
                        />
                      )
                    )
                      // no jobs 
                    }
                    {
                      !fetchAllJobsLoading && fetchAllJobs && fetchAllJobs.jobsByDepartment?.length === 0 && (
                        <div className="flex items-center justify-center py-8 h-[200px]">

                          <div className="flex items-center justify-center flex-col gap-y-2 text-[#6B7280] text-[14px] font-[500]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-briefcase-off"
                            >
                              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                              <path d="M11 7h8a2 2 0 0 1 2 2v8m-1.166 2.818a1.993 1.993 0 0 1 -.834 .182h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2" />
                              <path d="M8.185 4.158a2 2 0 0 1 1.815 -1.158h4a2 2 0 0 1 2 2v2" />
                              <path d="M12 12v.01" />
                              <path d="M3 13a20 20 0 0 0 11.905 1.928m3.263 -.763a20 20 0 0 0 2.832 -1.165" />
                              <path d="M3 3l18 18" />
                            </svg>

                            <span className='text-center'>
                              There are no open jobs available.
                              <br></br> Please remove the filters and try again later.
                            </span>
                          </div>
                        </div>
                      )
                    }
                  </div>

                </div>


                <div className='max-w-full md:max-w-[710px] lg:max-w-[710px] m-auto h-auto pb-[52px] lg:pb-0'>
                  <div className='mt-5 w-full max-w-full md:max-w-[710px] lg:max-w-[710px] h-auto'>
                    <p className='text-center block text-[12px] md:text-[12] line-clamp-2 lg:text-[12px] leading-5 font-medium
                   text-[#030b3e5c]'>This site is secured by reCAPTCHA and is subject

                      <br></br>  to  Google’s   Privacy Policy and Terms of Service.
                    </p>
                    <hr className="mt-5"></hr>
                    <div className='flex flex-col items-center lg:flex-row justify-center lg:justify-between flex-wrap lg:flex-nowrap  w-full px-4 lg:px-0 py-5'>
                      <div className='text-[#6B7280] text-[13px] font-[500]'>Powered by
                        <strong className='ml-1'>teamer</strong>
                      </div>
                      <div className='text-[#6B7280] text-[13px] font-[500] flex items-start gap-x-2 lg:gap-x-4'>
                        <a href='https://teamer.app/page/privacy-policy' target='_blank'>Privacy Policy</a>
                        <a href='https://teamer.app/page/terms-of-service' target='_blank'>Terms of Service</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </main>

          </div>
        </div>
      </div>



      <Dialog open={ModelOpen} onClose={setModalOpen} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-[6px] top-[10px] hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setModalOpen(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                {/* <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >

                  Login
                </DialogTitle> */}
                <div className="w-full bg-white py-0 rounded-md mt-0 lg:mt-0 mb-[0rem]">
                  <div className="mb-10">
                    <h2 className="text-left font-medium leading-5 text-dark-black-100 text-[16px]">
                      {step === 'initial' && 'Login to teamer'}
                      {step === 'email' && 'Enter Your Email'}
                      {step === 'otp' && 'Enter Your OTP'}
                    </h2>
                  </div>
                  <div>
                    {step === 'initial' && (
                      <div className="space-y-4">
                        <GoogleLoginButton onSuccess={onLoginSuccess} />
                        <div className="relative">
                          <div className="absolute inset-0 flex items-center">
                            <span className="w-full border-t" />
                          </div>
                          <div className="relative flex justify-center">
                            <span className="bg-white px-2 text-dark-black-200">Or continue with</span>
                          </div>
                        </div>
                        <button
                          onClick={() => setStep('email')}
                          className="flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm button-hover"
                        >
                          Continue with Email
                        </button>
                      </div>
                    )}
                    {step === 'email' && (
                      <EmailLoginForm
                        onSubmit={(email) => {
                          setEmail(email);
                          setStep('otp');
                        }}
                        onBack={() => setStep('initial')}
                      />
                    )}
                    {step === 'otp' && (
                      <OtpVerification
                        email={email}
                        onSuccess={onLoginSuccess}
                        onBack={() => setStep('email')}
                        setModalOpen={setModalOpen}
                      />
                    )}
                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>




    </>

  )
}

export default JobListing